export const questionSectionsEndPoint = 'question-sections';
export const questionSectionStrokesEndPoint = 'section-strokes';
export const questionSectionAssetsEndPoint = 'section-assets';
